module.exports = __webpack_public_path__ + "static/media/logoHand.d727dc38.svg";